import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { getWebAppUrl } from '../utils/config';
import { DEFAULT_TRIAL_PERIOD_DAYS } from '../config/config';

const FinalCTA: React.FC = () => {
  const handleStartTrial = () => {
    window.location.href = `${getWebAppUrl()}/create-account`;
  };

  return (
    <section className="cta-section-modern">
      <Container>
        <Row>
          <Col lg={8} className="mx-auto text-center">
            <h2 className="cta-title-modern mb-4">
              Ready to build your revenue engine?
            </h2>
            <p className="cta-subtitle-modern mb-5">
              Get CRM plus custom integrations, lead funnels, and sales automation pipelines built for your business
            </p>

            <div className="d-flex flex-wrap gap-3 justify-content-center mb-4">
              {DEFAULT_TRIAL_PERIOD_DAYS > 0 ? (
                <Button
                  className="btn-modern-primary"
                  onClick={handleStartTrial}
                >
                  Start {DEFAULT_TRIAL_PERIOD_DAYS}-Day Free Trial
                </Button>
              ) : (
                <Button
                  className="btn-modern-primary"
                  onClick={handleStartTrial}
                >
                  Get Started
                </Button>
              )}
              <Button
                className="btn-modern-secondary"
                onClick={() => window.location.href = '#pricing'}
              >
                View Pricing
              </Button>
            </div>

            {DEFAULT_TRIAL_PERIOD_DAYS > 0 && (
              <p className="cta-caption">
                {DEFAULT_TRIAL_PERIOD_DAYS}-day trial • No credit card required • Cancel anytime
              </p>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FinalCTA;
